import React from 'react';
import MaterialTableHead from '@material-ui/core/TableHead';
import RowOrder from './RowOrder';
import RowFilter from './RowFilter';

const TableHead = () => {
    return (
        <MaterialTableHead>
            <RowOrder/>
            <RowFilter/>
        </MaterialTableHead>
    );
};

export default TableHead;
